import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import OEIInput from './OEIInput';
import {
  CHECKED,
  BUSINESSLINE1,
  BUSINESSLINE2,
  BUSINESSLINE3,
  BUSINESSLINE4,
  BUSINESSLINE5,
  BUSINESSLINE6,
  BUSINESSLINE7,
  BUSINESSLINE8,
  BUSINESSLINE9,
  BUSINESSLINE10,
  BUSINESSLINE11,
  UNCHECKED,
  EDIT_CENTRAL_MAPPING,
  NEW_CENTRAL_MAPPING,
  DISABLED,
  EMPTY,
  EDIT
} from './Constants';

function NewSalesforceMppingPopover({
  type,
  newData,
  errors,
  setNewData,
  setErrors,
  setMiddlePopoverName,
  setCheckedList,
  removeMainItem,
  middlePopoverName
}) {
  const setSalesforceAccountNumber = useCallback((e) => {
    setNewData({ ...newData, salesforceAccountNumber: e });
    setErrors({ ...errors, error1: EMPTY });
  }, [setNewData, setErrors, newData, errors]);

  const setSalesforceAccountName = useCallback((e) => {
    setNewData({ ...newData, salesforceAccountName: e });
    setErrors({ ...errors, error2: EMPTY });
  }, [setNewData, setErrors, newData, errors]);

  const getAllCheckedList = useCallback((data) => {
    let list = [];
    data.forEach(item => list.push(...item.checkedList));
    return list;
  }, []);

  const setStatus = useCallback((totalList, checkedList, key) => {
    return checkedList.includes(key) ? CHECKED : totalList.includes(key) ? DISABLED : UNCHECKED;
  }, []);

  const openCentralMapping = useCallback(() => {
    let totalList = getAllCheckedList(newData.centralData);
    setMiddlePopoverName(NEW_CENTRAL_MAPPING);
    setNewData({ ...newData, checkedList: [], oeCentralAccountName: EMPTY, oeCentralAccountNumber: EMPTY });
    setCheckedList([
      { key: BUSINESSLINE1, value: setStatus(totalList, [], BUSINESSLINE1) },
      { key: BUSINESSLINE2, value: setStatus(totalList, [], BUSINESSLINE2) },
      { key: BUSINESSLINE3, value: setStatus(totalList, [], BUSINESSLINE3) },
      { key: BUSINESSLINE4, value: setStatus(totalList, [], BUSINESSLINE4) },
      { key: BUSINESSLINE5, value: setStatus(totalList, [], BUSINESSLINE5) },
      { key: BUSINESSLINE6, value: setStatus(totalList, [], BUSINESSLINE6) },
      { key: BUSINESSLINE7, value: setStatus(totalList, [], BUSINESSLINE7) },
      { key: BUSINESSLINE8, value: setStatus(totalList, [], BUSINESSLINE8) },
      { key: BUSINESSLINE9, value: setStatus(totalList, [], BUSINESSLINE9) },
      { key: BUSINESSLINE10, value: setStatus(totalList, [], BUSINESSLINE10) },
      { key: BUSINESSLINE11, value: setStatus(totalList, [], BUSINESSLINE11) }
    ]);
    setErrors({ ...errors, error6: EMPTY, error3: EMPTY, error4: EMPTY, error5: EMPTY });
  }, [getAllCheckedList, setNewData, setMiddlePopoverName, setCheckedList, setErrors, newData, errors, setStatus]);

  const edit = useCallback((item) => {
    let totalList = getAllCheckedList(newData.centralData);
    setNewData({ ...newData, checkedList: item.checkedList, editItem: item, oeCentralAccountName: item.oeCentralAccountName, oeCentralAccountNumber: item.oeCentralAccountNumber });
    setCheckedList([
      { key: BUSINESSLINE1, value: setStatus(totalList, item.checkedList, BUSINESSLINE1) },
      { key: BUSINESSLINE2, value: setStatus(totalList, item.checkedList, BUSINESSLINE2) },
      { key: BUSINESSLINE3, value: setStatus(totalList, item.checkedList, BUSINESSLINE3) },
      { key: BUSINESSLINE4, value: setStatus(totalList, item.checkedList, BUSINESSLINE4) },
      { key: BUSINESSLINE5, value: setStatus(totalList, item.checkedList, BUSINESSLINE5) },
      { key: BUSINESSLINE6, value: setStatus(totalList, item.checkedList, BUSINESSLINE6) },
      { key: BUSINESSLINE7, value: setStatus(totalList, item.checkedList, BUSINESSLINE7) },
      { key: BUSINESSLINE8, value: setStatus(totalList, item.checkedList, BUSINESSLINE8) },
      { key: BUSINESSLINE9, value: setStatus(totalList, item.checkedList, BUSINESSLINE9) },
      { key: BUSINESSLINE10, value: setStatus(totalList, item.checkedList, BUSINESSLINE10) },
      { key: BUSINESSLINE11, value: setStatus(totalList, item.checkedList, BUSINESSLINE11) }
    ]);
    setMiddlePopoverName(EDIT_CENTRAL_MAPPING);
  }, [getAllCheckedList, setNewData, setMiddlePopoverName, setCheckedList, newData, setStatus]);

  const MappingItem = ({ item }) => (
    <div className="email_row">
      <div style={{ width: '120px' }} className="m overflow-ellipsis">{item.oeCentralAccountName}</div>
      <div className="m overflow-ellipsis">{item.oeCentralAccountNumber}</div>
      <button type="button" onClick={() => { edit(item) }} className="default-button default-button--slim-edit default-button--link visible-while-hovered">
        <span>Edit</span>
      </button>
      <button onClick={() => removeMainItem(item)} type="button" style={{ color: "#ff0000" }} className="default-button default-button--slim-edit default-button--link visible-while-hovered email-remove-label">
        <span>Remove</span>
      </button>
    </div>
  );

  return (
    <>
      {type === 'New' || (type === EDIT && newData.salesforceAccountNumber !== undefined) ? (
        <>
          <OEIInput
            value={newData.salesforceAccountNumber}
            setValue={setSalesforceAccountNumber}
            newData={newData}
            name="salesforceAccountNumber"
            errorMessage={errors.error1}
            label="Salesforce Account Number"
            showError={false}
          />
          <OEIInput
            value={newData.salesforceAccountName}
            setValue={setSalesforceAccountName}
            newData={newData}
            name="salesforceAccountName"
            errorMessage={errors.error2}
            label="Salesforce Account Name"
            showError={false}
          />
          <div className="oe-form-field">
            <label style={{ color: '#1A1A1A', paddingLeft: '0px', display: 'flex' }} className="attendee-list__label event_form__items-section__title">
              Mappings
            </label>
            {newData.centralData && newData.centralData.map((item) => (
              <MappingItem key={item.oeCentralAccountNumber} item={item} />
            ))}
            <div className="m">
              <button
                type="button"
                className="email-new"
                style={{ cursor: 'pointer', backgroundColor: middlePopoverName === NEW_CENTRAL_MAPPING ? '#C4F8E4' : '', color: middlePopoverName === NEW_CENTRAL_MAPPING ? '#1A1A1A' : '' }}
                onClick={openCentralMapping}
              >
                <span>+ New OE Central Account Mapping</span>
              </button>
            </div>
            <div className="oe-form-field__error">{errors.error6}</div>
          </div>
        </>
      ) : (
        <div className="oe-form-field">
          <label style={{ fontSize: '12px', color: '#1A1A1A', paddingLeft: '0px', display: 'flex' }} className="attendee-list__label event_form__items-section__title">
            Loading Salesforce Data ...
          </label>
        </div>
      )}
    </>
  );
}

NewSalesforceMppingPopover.propTypes = {
  type: PropTypes.string.isRequired,
  newData: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setNewData: PropTypes.func.isRequired,
  setErrors: PropTypes.func.isRequired,
  setMiddlePopoverName: PropTypes.func.isRequired,
  setCheckedList: PropTypes.func.isRequired,
  removeMainItem: PropTypes.func.isRequired,
  middlePopoverName: PropTypes.string.isRequired
};

export default NewSalesforceMppingPopover;
